module.exports = __webpack_public_path__ + "img/crossed_fingers.057d54aa.png";